import React, { useState } from "react";
import { percentOf } from "./chartTheme";

/**
 * Card shell every chart in the report sits in: title, optional subtitle, and
 * a chart/table toggle.
 *
 * The table view is not a nicety - several categorical slots sit below 3:1
 * against the white surface, and the palette gate only clears with that relief
 * in place. It also gives screen readers and printed copies the exact numbers.
 */
export default function ChartCard({
  title,
  subtitle,
  children,
  tableRows = [],
  tableHeaders = ["Segment", "Applicants", "Share"],
  total,
}) {
  const [showTable, setShowTable] = useState(false);
  const canToggle = tableRows.length > 0;

  return (
    <div className="chart-card">
      <div className="chart-card-head">
        <div>
          <h4 className="chart-card-title">{title}</h4>
          {subtitle && <span className="chart-card-subtitle">{subtitle}</span>}
        </div>
        {/* {canToggle && (
          <button
            type="button"
            className="chart-card-toggle"
            onClick={() => setShowTable((v) => !v)}
            aria-pressed={showTable}
          >
            {showTable ? "Chart" : "Table"}
          </button>
        )} */}
      </div>

      <div className="chart-card-body">
        {showTable ? (
          <div className="table-container viz-table-view mb-0">
            <table className="ant-table">
              <thead>
                <tr>
                  {tableHeaders.map((h, i) => (
                    <th key={h} className={i === 0 ? "" : "text-end"}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tableRows.map((row) => (
                  <tr key={row.name}>
                    <td>{row.name}</td>
                    <td className="text-end">{row.value}</td>
                    <td className="text-end">{percentOf(row.value, total)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
}
